'use client'

import Contact from '@/components/Contact'
import DynamicFAQ from '@/components/DynamicFAQ'
import { motion } from 'framer-motion'
import { MessageCircle } from 'lucide-react'

export default function ContactPage() {
  return (
    <main className="min-h-screen pt-20">
      {/* Page Hero */}
      <section className="bg-gradient-to-br from-sky-50 via-white to-blue-50 py-16 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-80 h-80 bg-sky-100/40 rounded-full blur-3xl" />
        <div className="container mx-auto px-6 relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="text-center max-w-2xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-sky-100 text-sky-600 text-sm font-medium mb-4">
              <MessageCircle className="w-4 h-4" /> Contact Us
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Let's <span className="gradient-text">Connect</span>
            </h1>
            <p className="text-slate-500">
              Have a project in mind? We'd love to hear about it. Get in touch and let's build something great together.
            </p>
          </motion.div>
        </div>
      </section>

      <Contact />
      
      <DynamicFAQ 
        title="Frequently Asked Questions"
        subtitle="Find answers to commonly asked questions about our services"
        showSearch={true}
        showFilters={true}
        limit={10}
      />
    </main>
  )
}
